module.exports = __webpack_public_path__ + "img/10.ed6d3699.png";